import {
  Paper,
  Stack,
  Box,
  useTheme,
  createSvgIcon,
  Button,
  Tooltip,
} from "@mui/material";

import { ReactComponent as IconRouter } from "../../../../assets/easyMaps/Router.svg";
import ElementHeader from "../../../../componentes/easyMaps/elementHeader";

export default function CardHosts(props) {
  const { host, setFocusNodeId, iconsElement, isScrolling } = props;
  const theme = useTheme();

  const styles = {
    line: {
      backgroundColor: "primary.main",
      height: "60px",
      width: "3px",
    },
    text: {
      marginTop: "-3px",
      fontSize: "0.8em",
      maxWidth: "190px",
      overflow: "hidden",
      textOverflow: "ellipsis",
      whiteSpace: "nowrap",
    },

    card: {
      backgroundColor: theme.palette.background.paperSelectedMaps,
      boxShadow: "0px 0px 5px  #0000001a",
      position: "relative",
      width: "100%",
      padding: "15px 10px",
      display: "flex",
      direction: "row",
      height: "90px",
      alignItems: "center",
      gap: 2,
      "&:hover": {
        backgroundColor: theme.palette.background.hover,
      },
    },
  };

  return (
    <Tooltip title={host?.name} placement="left">
      <Button
        onClick={() => setFocusNodeId(host?.id)}
        sx={{
          padding: "0px",
          width: isScrolling ? "97%" : "100%",
        }}
      >
        <Paper elevation={0} sx={styles.card}>
          <Box ml={-1}>
            <ElementHeader
              tipo={host.tipo}
              titulo={host.titulo}
              interfaces={
                Array.isArray(host?.elementConfig?.config?.hosts) &&
                host?.elementConfig.config?.hosts?.length > 0
                  ? host?.elementConfig?.config?.hosts[0]?.interfaces
                  : []
              }
              tags={
                Array.isArray(host?.elementConfig?.config?.hosts) &&
                host?.elementConfig?.config?.hosts?.length > 0
                  ? host?.elementConfig?.config?.hosts[0]?.tags
                  : []
              }
              img={
                iconsElement?.find((icon) => icon.id == host.img)?.img ||
                iconsElement?.find((icon) => icon.nome == "_roteador").img
              }
            />
          </Box>
        </Paper>
      </Button>
    </Tooltip>
  );
}
